import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { NAV_ITEMS } from "./nav";

/**
 * The phone's main navigation: a tab bar along the bottom, within thumb
 * reach. Icons only (the page name is in the top bar): the open tab in full
 * colour, the resting ones in grey. Each link keeps its page name for screen
 * readers.
 */
export function BottomNav() {
	return (
		<nav
			aria-label="Main"
			className="fixed inset-x-0 bottom-0 z-40 border-t border-separator bg-surface pb-[env(safe-area-inset-bottom)]"
		>
			<ul className="mx-auto grid max-w-lg grid-cols-6">
				{NAV_ITEMS.map((item) => (
					<li key={item.path}>
						<NavLink
							to={item.path}
							end={item.path === "/"}
							aria-label={item.label}
							className="flex h-12 items-center justify-center outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus"
						>
							{({ isActive }) => (
								<img
									src={item.icon}
									alt=""
									aria-hidden
									className={cn("size-6 transition-[filter,opacity] duration-150", !isActive && "opacity-70 brightness-75 grayscale dark:opacity-45 dark:brightness-100")}
								/>
							)}
						</NavLink>
					</li>
				))}
			</ul>
		</nav>
	);
}
